import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CALENDLY } from "../../data/content";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <div className={`flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.22em] ${light ? "text-cobalt-200" : "text-cobalt-700"}`}>
    <span className={`h-px w-8 ${light ? "bg-cobalt-200" : "bg-cobalt-700"}`} />
    {children}
  </div>
);

export const CtaButton = ({ children, testId, variant = "solid", href = CALENDLY, className = "" }) => {
  const styles = {
    solid: "bg-ink text-paper hover:bg-cobalt-700",
    light: "bg-paper text-ink hover:bg-white",
    ghost: "border border-ink/15 text-ink hover:border-ink hover:bg-ink hover:text-paper",
    cobalt: "bg-cobalt-700 text-white hover:bg-ink",
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`group inline-flex items-center gap-3 rounded-full py-2 pl-6 pr-2 text-[15px] font-semibold transition-colors duration-300 ${styles[variant]} ${className}`}
    >
      <span>{children}</span>
      <span className="grid h-9 w-9 place-items-center overflow-hidden rounded-full bg-white/15 ring-1 ring-current/10">
        <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:rotate-45" />
      </span>
    </a>
  );
};
